import { Link, useParams } from 'react-router'
import Table from '../Components/AdminTable.js'
import { useEffect, useState } from 'react'
import { call } from '../Methods.js'
import { use } from '../Helpers.js'
import FormModal from '../Components/FormModal.js'

function Payments () {
  const pageName = 'payments'
  const pageTitle = 'Ödənişlər'
  document.title = `${pageTitle} | ${process.env.REACT_APP_NAME}` 
  const [updateTable, setUpdateTable] = useState(false)

  useEffect(() => {
    if (updateTable) {
      setUpdateTable(false)
    }
  }, [updateTable])

  const tableSettings = {
    name: '',
    label: '',
    filters: true,
    pagination:true,
    actions: {
      get: async (params = {}) => {
        const payments = await call.forLoggedUser.payment.getPayments(params)
        if (payments.success) {
          return payments.data
        }
        return []
      }
    },
    columns: [
      {
        title: '#',
        property: 'rowNumber',
        style: { width: '30px' },
        filter: {
          enabled: false
        }
      },
      {
        title: 'Tarix',
        property: 'paidDate',
        style: { width: '10%' },
        filter: {
          enabled: true,
          type: 'month',
          name: 'paidMonth'
        },
        mutate: value => {
          return use.convertDatetimeToShortDate(value)
        }
      },
      {
        title: 'Filial',
        property: ['branchCode','branchName'],
        mutate:(values)=><span title={values[1]}>{values[0]}</span>,
        filter: {
          enabled: true,
          type: 'select',
          name:'branchId',
          dataSource:async ()=> {
            const source = await call.forLoggedUser.branch.getBranches({})
            let data = source.data.map(d => {
              return { value: d.id, text: d.code }
            })
            return data
          }
        },
        style: {width:'15%'},
      },
      {
        title: 'İştirakçı/Namizəd',
        property: 'fullName',
        style: { width: '25%' },
        filter: {
          enabled: true,
          type: 'text',
          name: 'studentFullName'
        }
      },
      {
        title: 'Qrup',
        property: 'groupName',
        style: { width: '20%' },
        mutate:(value)=>value==null?'-':value,
        filter: {
          enabled: true,
          type: 'select',
          name: 'groupId',
          dataSource: async () => {
            const source = await call.forLoggedUser.group.getGroups({})
            let data = source.data.map(d => {
              return { value: d.id, text: d.name }
            })
            return data
          }
        }
      },
      {
        title: 'Məbləğ',
        property: 'amount',
        style: { width: '10%' },
        filter: {
          enabled: true,
          type: 'number',
          name: 'amount'
        },
        mutate:(value)=>{
          return <p style={{textAlign:'right',paddingRight:'7px'}}>{value} ₼</p>
        }
      },
      {
        title: 'Status',
        property: 'statusName',
        type:'status-label',
        style: { width: '10%' },
        filter: {
          enabled: true,
          type: 'select',
          name: 'statusId',
          dataSource: async () => {
            const source = await call.forLoggedUser.status.getStatuses({
              type: 'payment'
            })
            let data = source.data.map(d => {
              return { value: d.id, text: d.description }
            })
            return data
          }
        },
        mutate: value => {
          return value
        }
      },
      {
        title: 'Əməliyyat',
        property:'id',
        type: 'actions-list',
        style: {width:'10%',minWidth: '50px'},
        operations:(value)=>[
          {
            type:'link',
            name:'Edit',
            title:'Düzəliş',
            link:`${value}`,
            iconType:'path',
            icon:'/Images/Icons/edit.png',
            disablingConditions:[],
          },
          {
            type:'command',
            name:'delete',
            title:'Qeydi sil',
            parameters:`{"id":${value},"entity":"payment"}`,
            iconType:'path',
            icon:'/Images/Icons/delete.png',
            disablingConditions:[]
          },
        ],
      }
    ],
    addNew: {
      enabled: true,
      url: `/${pageName}/add`,
      title: '+ Əlavə et'
    }
  }

  const formSettings = [
    {
      name: 'payment',
      id: '',
      label: 'Ödəniş',
      isMain: true,
      actions: {
        get: id => call.forLoggedUser.payment.getPaymentById({ id: id }),
        add: call.forLoggedUser.payment.addPayment,
        edit: call.forLoggedUser.payment.updatePayment
      },
      formLists:{
        Students:async () => {
            const source = await call.forLoggedUser.student.getActiveStudents({})
            let data = source.data.map(d => {
              return { value: d.id, text: `${d.name} ${d.surname} (${d.groupName || d.courseCode})` }
            })
            return data
          },
          PaymentTypes:async () => {
            const source = await call.forLoggedUser.listOption.getListOptions({
              listName: 'PaymentType'
            })
            let data = source.data.map(d => {
              return { value: d.value, text: d.text }
            })
            return data
          },
          Statuses:async () => {
            const source = await call.forLoggedUser.status.getStatuses({
              type: 'payment'
            })
            let data = source.data.map(d => {
              return { value: d.id, text: d.description }
            })
            return data
          }
      },
      fields: [
        { type: 'hidden', fieldName: 'id', label: '' },
        { type: 'hidden', fieldName: 'groupId', label: '' },
        {
          label: 'Ödəniş tarixi',
          type: 'date',
          fieldName: 'paidDate',
          validationRules: ['required'],
          col: { sm: 3 },
          defaultValue: new Date().toLocaleDateString('az-AZ'),
          mutate: value => {
            return value!=null ? new Date(value).toLocaleDateString('az-AZ'): null
          }
        },
        {
          label: 'İştirakçı/Namizəd',
          type: 'select',
          fieldName: 'studentId',
          validationRules: ['required'],
          defaultSelectOptions: [{ value: '', text: 'Seçilməyib...' }],
          col: { sm: 3 },
          data:'Students' 
        },
        {
          label: 'Məbləğ',
          type: 'number',
          fieldName: 'amount',
          validationRules: ['required'],
          col: { sm: 3 }
        },
        {
          label: 'Ödəniş forması',
          type: 'select',
          fieldName: 'paymentTypeId',
          col: { sm: 3 },
          data:'PaymentTypes' 
        },
        {
          label: 'Açıqlama',
          type: 'text',
          fieldName: 'description',
          col: { sm: 6 }
        },
        {
          label: 'Status',
          type: 'select',
          fieldName: 'statusId',
          defaultValue: 0,
          col: { sm: 6 },
          data:'Statuses' 
        },
        {
          label: 'Əlavə Qeydlər',
          type: 'textarea',
          fieldName: 'notes',
          col: { sm: 6 }
        },
        { type: 'submit', label: 'Təsdiq', col: { sm: 12 } }
      ]
    }
  ]

  return (
    <div className='page'>
      <h1 className='page-title'>{pageTitle}</h1>
      <Table tableSettings={tableSettings} updateTable={updateTable} />

      <FormModal
        moduleUrl={`/${pageName}`}
        formSettings={formSettings}
        onSubmit={() => setUpdateTable(true)}
      />
    </div>
  )
}

export default Payments
